import { useServiceRecordContext } from '@euler/app/flows/record/ServiceRecordContext';
import { EmptyQuotationFormView } from '@euler/app/flows/task/pages/quotation/components/EmptyQuotationFormView';
import { usePrintQuotationForm } from '@euler/app/flows/task/pages/quotation/functions/usePrintQuotationForm';
import { Aside } from '@euler/components/Aside';
import { adaptiveWrapperOptions } from '@euler/functions/navigationOptionsBuilder';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import {
  isMobileLayout,
  useIsMobileLayout,
} from '@euler/functions/responsiveness';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { QuotationSubject } from '@euler/model/task-detail';
import { memo, useCallback } from 'react';
import { FlatList, ListRenderItem } from 'react-native';
import invariant from 'tiny-invariant';
import { ReadonlyQuotationFormFooter } from './components/Footer';
import { ReadonlyQuotationFormSubjectPanel } from './components/SubjectPanel';

const keyExtractor = (subject: QuotationSubject) => subject.name;

export const ServiceRecordQuotationFormPage = wrapNavigatorScreen(
  () => {
    const isMobile = useIsMobileLayout();

    if (isMobile) {
      return <Content />;
    }
    return (
      <Aside dismissible>
        <Content />
      </Aside>
    );
  },
  adaptiveWrapperOptions<any>(() => ({
    title: '维修报价单',
    headerStatusBarHeight: undefined,
    headerShown: isMobileLayout(),
  })),
);

const Content = memo(() => {
  const { rpx } = useResponsiveContext();

  const { serviceRecord } = useServiceRecordContext();
  const form = serviceRecord.quotationForm;
  invariant(form != null);

  const renderItem: ListRenderItem<QuotationSubject> = useCallback(
    ({ item, index }) => {
      return (
        <ReadonlyQuotationFormSubjectPanel
          subject={item}
          index={index}
          css={`
            margin-top: ${rpx(10)}px;
          `}
        />
      );
    },
    [rpx],
  );

  const onPrint = usePrintQuotationForm(serviceRecord.orderNo, {
    type: 'quotation-form',
    showPrice: true,
  });

  if (!form.subjects.length) {
    return <EmptyQuotationFormView />;
  }

  return (
    <>
      <FlatList
        data={form.subjects}
        renderItem={renderItem}
        keyExtractor={keyExtractor}
        keyboardShouldPersistTaps="handled"
        initialNumToRender={20}
        contentContainerStyle={{
          paddingBottom: rpx(15),
          flexGrow: 1,
        }}
      />
      <ReadonlyQuotationFormFooter form={form} onPrint={onPrint} />
    </>
  );
});
